import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';

import { IUser } from '@azavista/planner-lib';
import { IAppThemeChangedData, IScannedCodeValue } from './interfaces';

@Injectable({
    providedIn: 'root'
})
export class SubjectsService {
    private requestQRCodeScan = new Subject<void>();
    private qrCodeScanStarted = new Subject<void>();
    private stopQRCodeScan = new Subject<void>();
    private qrCodeAvailable = new Subject<IScannedCodeValue>();
    private currentUserAvailable = new BehaviorSubject<IUser | null>(null);
    private toolbarMenuButtonClicked = new Subject<void>();
    private changeHandheldScannerEnabled = new BehaviorSubject<boolean>(false);
    private clearCachedBadges = new Subject<void>();
    private readonly themeChanged = new ReplaySubject<IAppThemeChangedData>(1);
    private readonly themeChanged$ = this.themeChanged.asObservable();

    getClearCachedBadgesSubject(): Subject<void> {
        return this.clearCachedBadges;
    }

    getClearCachedBadgesObservable(): Observable<void> {
        return this.clearCachedBadges.asObservable();
    }

    getChangeHandheldScannerEnabledSubject(): BehaviorSubject<boolean> {
        return this.changeHandheldScannerEnabled;
    }

    getChangeHandheldScannerEnabledObservable(): Observable<boolean> {
        return this.changeHandheldScannerEnabled.asObservable();
    }

    getToolbarMenuButtonClickedSubject(): Subject<void> {
        return this.toolbarMenuButtonClicked;
    }

    getToolbarMenuButtonClickedObservable(): Observable<void> {
        return this.toolbarMenuButtonClicked.asObservable();
    }

    getCurrentUserAvailableSubject(): BehaviorSubject<IUser | null> {
        return this.currentUserAvailable;
    }

    getCurrentUserAvailableObservable(): Observable<IUser | null> {
        return this.currentUserAvailable.asObservable();
    }

    getQRCodeScanStartedSubject(): Subject<void> {
        return this.qrCodeScanStarted;
    }

    getQRCodeScanStartedObservable(): Observable<void> {
        return this.qrCodeScanStarted.asObservable();
    }

    getQRCodeAvailableSubject(): Subject<IScannedCodeValue> {
        return this.qrCodeAvailable;
    }

    getQRCodeAvailableObservable(): Observable<IScannedCodeValue> {
        return this.qrCodeAvailable.asObservable();
    }

    getStopQRCodeScanSubject(): Subject<void> {
        return this.stopQRCodeScan;
    }

    getStopQRCodeScanObservable(): Observable<void> {
        return this.stopQRCodeScan.asObservable();
    }

    getRequestQRCodeScanObservable(): Observable<void> {
        return this.requestQRCodeScan.asObservable();
    }

    getRequestQRCodeScanSubject(): Subject<void> {
        return this.requestQRCodeScan;
    }

    getThemeChangedSubject(): Subject<IAppThemeChangedData> {
        return this.themeChanged;
    }

    getThemeChangedObservable(): Observable<IAppThemeChangedData> {
        return this.themeChanged$;
    }
}
